/*
 * D4's activity panel — now one line of re-export over the shared drawing.
 *
 * 🔴 THE ~230 LINES THAT WERE HERE MOVED TO `shared/components/ActivityLineChart`
 * WHEN THE SCHOOL TIER NEEDED THE SAME PICTURE. Every word of the reasoning —
 * why two series, why no smoothing, why zeroes are drawn, why the floor is
 * always zero — travelled with the code and is unchanged there. Nothing about
 * how a class's fortnight is drawn has changed.
 *
 * ⚠️ THIS FILE STAYS RATHER THAN EVERY CALLER BEING REPOINTED, and the reason
 * is `classActivityChart.test.ts`. It imports `ceiling`, `pathFor`, `ticks` and
 * `axisLabel` from this path and asserts the maths that keeps a quiet week from
 * being drawn as a busy one. Those assertions are about behaviour that did not
 * move, so the test should not have to move either — a rename that forces a
 * green test to be rewritten is a rename that loses whatever the test was
 * holding.
 *
 * ⚠️ `ClassActivityChartProps` KEEPS `ActivityPoint` FROM THIS TIER'S API. The
 * shared component is structural (`ActivityLinePoint`), which `ActivityPoint`
 * satisfies — so the teacher's call sites stay typed against the payload they
 * actually receive rather than against a shape that merely resembles it.
 */
import {
  ActivityLineChart,
  axisLabel,
  ceiling,
  pathFor,
  ticks,
} from '../../../shared/components/ActivityLineChart'
import type { ActivityPoint } from '../../../shared/api/teaching'

export { axisLabel, ceiling, pathFor, ticks }

export interface ClassActivityChartProps {
  points: readonly ActivityPoint[]
  copy: {
    sessions: string
    children: string
    nothingYet: string
  }
}

export function ClassActivityChart({ points, copy }: ClassActivityChartProps) {
  return <ActivityLineChart points={points} copy={copy} />
}
